export const transactionStatus = (status) => {
    switch (status) {
        case 'QUOTE_ACCEPT':
            return 'Quote Accept'
        case 'AMEND_ACCEPT':
            return 'Amend Accept'
        case 'REFUND':
            return 'Refund'
        case 'PAYOUT':
            return 'Payout'
        default:
            return '-';
    }
}